import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Trophy, 
  Info, 
  FileText, 
  Github, 
  ExternalLink,
  Heart
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 border-t border-gray-700 mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-gradient-to-r from-primary-500 to-purple-500 rounded-lg">
                <Trophy className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold gradient-text">CS2 Skins</h3>
                <p className="text-xs text-gray-400 -mt-1">Ranking</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Discover the most popular CS2 skins based on professional player usage and community preferences.
            </p>
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <span>Made with</span>
              <Heart className="h-4 w-4 text-red-400" />
              <span>for the CS2 community</span>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center space-x-2"
                >
                  <Trophy className="h-4 w-4" />
                  <span>Rankings</span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/ranking-system" 
                  className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center space-x-2"
                >
                  <Info className="h-4 w-4" />
                  <span>How It Works</span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center space-x-2"
                >
                  <FileText className="h-4 w-4" />
                  <span>Terms & Conditions</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Categories</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/?category=rifles" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Rifles
                </Link>
              </li>
              <li>
                <Link to="/?category=pistols" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Pistols
                </Link>
              </li>
              <li>
                <Link to="/?category=smgs" className="text-gray-400 hover:text-white transition-colors duration-200">
                  SMGs
                </Link>
              </li>
              <li>
                <Link to="/?category=shotguns" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Shotguns
                </Link>
              </li>
              <li>
                <Link to="/?category=machine guns" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Machine Guns
                </Link>
              </li>
              <li>
                <Link to="/?category=knives" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Knives
                </Link>
              </li>
            </ul>
          </div>

          {/* External Links & Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Contacts</h4>
            <div className="text-sm text-gray-500">
            Please contact us at support@eloskins.com with any questions or collaboration inquiries.
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-500">
              © {currentYear} CS2 Skins Ranking. All rights reserved.
            </div>
            
            <div className="flex items-center space-x-6 text-sm text-gray-500">
              <span>
                Not affiliated with Valve Corporation
              </span>
              <span className="hidden md:block">•</span>
              <span>
                Counter-Strike 2 is a trademark of Valve Corporation
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
